import React from 'react';
import me from '../../assets/pictures/MePiccolo.jpg';
import meNow from '../../assets/pictures/currentme.jpg';
import { Link } from 'react-router-dom';
import ResumeDownload from './ResumeDownload';

export interface AboutProps {}

const About: React.FC<AboutProps> = (props) => {
    return (
        // add on resize listener
        <div className="site-page-content">
            {/* <img src={me} style={styles.topImage} alt="" /> */}
            <h1 style={{ marginLeft: -16 }}>Benvenuto</h1>
            <h3>Sono Marangoni Davide</h3>
            <br />
            <div className="text-block">
                <p>
                    Sono Marangoni Davide, fondatore di MISMO STUDIO. Uno studio grafico che 
                    cerca di ragionare fuori dal comune, cercando di creare opere uniche e originali.
                </p>
                <br />
                <p>
                    Grazie per aver dedicato del tempo a visitare il mio portfolio. 
                    Spero davvero che tu possa apprezzarlo tanto quanto io ho apprezzato 
                    crearlo. Se hai domande o commenti, sentiti libero di contattarmi usando{' '}
                    <Link to="/contact">questo form</Link> o inviami un'email a{' '}
                    <a href="mailto:marangonidavide05@gmail.com">
                        marangonidavide05@gmail.com
                    </a>
                </p>
            </div>
            <ResumeDownload />
            <div className="text-block">
                <h3>About Me</h3>
                <br />
                <p>
                    Fin da piccolo ho sempre avuto una grande curiosità per i computer. 
                    Questa passione si è concretizzata sempre più negli anni grazie agli 
                    studi fatti e alle innumerevoli ore di apprendistato dedicate. 
                    Quella che era una semplice curiosità infantile si è trasformata 
                    in un vero e proprio lavoro grazie alla grande dedizione e costanza.
                </p>
                <br />
                <div className="captioned-image">
                    <img src={me} style={styles.image} alt="" />
                    <p>
                        <sub>
                            <b>Figure 1:</b> Foto mentre capivo cosa fosse una macchina fotografica
                        </sub>
                    </p>
                </div>
                <p>
                    Durante il mio percorso scolastico ho sempre alternato lo studio 
                    con il lavoro: la mattina ero a scuola e il pomeriggio in ufficio. 
                    Questa doppia esperienza mi ha permesso di portare ottimi risultati 
                    in entrambe le situazioni, imparando a gestire tempo, responsabilità 
                    e a mettere in pratica subito ciò che apprendevo. La teoria si 
                    incontrava con la pratica quotidianamente, creando una formazione 
                    completa e concreta.
                </p>
                <br />
                <p>
                    Questa esperienza mi ha portato a fondare MISMO STUDIO, uno studio 
                    grafico con un approccio differente, alternativo e innovativo. 
                    Il mio obiettivo è rivoluzionare e aiutare il mercato della grafica 
                    e comunicazione, portando una visione fresca e contemporanea che 
                    rompe gli schemi tradizionali.
                </p>
                <br />
                <br />
                
                <br />
                <br />
                
                <br />
                <p>
                    Se hai domande o hai in mente un nuovo progetto,
                    Puoi raggiungermi attraverso la{' '}
                    <Link to="/contact">pagina contatti</Link> o inviarmi un'email 
                    all'indirizzo{' '}
                    <a href="mailto:marangonidavide05@gmail.com">
                        marangonidavide05@gmail.com
                    </a>
                </p>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    contentHeader: {
        marginBottom: 16,
        fontSize: 48,
    },
    image: {
        height: 'auto',
        width: '100%',
    },
    topImage: {
        height: 'auto',
        width: '100%',
        marginBottom: 32,
    },
    verticalImage: {
        alignSelf: 'center',
        // width: '80%',
        marginLeft: 32,
        flex: 0.8,

        alignItems: 'center',
        // marginBottom: 32,
        textAlign: 'center',
        flexDirection: 'column',
    },
};

export default About;
